import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from '../core/layout/layout.component';

import { AuthGuardService } from 'src/app/modules/core/services/auth-guard.service';

import { LoginComponent } from 'src/app/modules/cpg/login/login.component';
import { DashboardComponent } from 'src/app/modules/cpg/dashboard/dashboard.component';
import { ChangePasswordComponent } from 'src/app/modules/cpg/change-password/change-password.component';
import { CreateCouponComponent } from 'src/app/modules/cpg/coupon/create-coupon/create-coupon.component';
import { CouponListComponent } from 'src/app/modules/cpg/coupon/coupon-list/coupon-list.component';
import { CouponReportComponent } from 'src/app/modules/cpg/reports/coupon-report/coupon-report.component';
import { PaymentsComponent } from 'src/app/modules/cpg/payments/payments.component';


const routes: Routes = [
  { path: 'cpg', component: LoginComponent },
  { path: 'cpg/dashboard', component: LayoutComponent, data: { module:'cpg' }, // Dashboard
    children: [
        { path: '', component: DashboardComponent, canActivate: [AuthGuardService], data: { module:'cpg', menuCode: 'C-DA' } }
    ]
  },
  { path: 'cpg/change-password', component: LayoutComponent, data: { module:'cpg' }, // Change Password
      children: [
          { path: '', component: ChangePasswordComponent, canActivate: [AuthGuardService], data: { module:'cpg', menuCode: 'C-ALL-USERS_ACCESS' } } 
      ]
  },
  { path: 'cpg/create-coupon', component: LayoutComponent, data: { module:'cpg' }, // Create Coupon
    children: [
        { path: '', component: CreateCouponComponent, canActivate: [AuthGuardService], data: { module:'cpg', menuCode: 'C-CC' } }
    ]
  },
  { path: 'cpg/coupon-list', component: LayoutComponent, data: { module:'cpg' }, // Coupon List
    children: [
        { path: '', component: CouponListComponent, canActivate: [AuthGuardService], data: { module:'cpg', menuCode: 'C-CL' } }
    ]
  },
  { path: 'cpg/reports', component: LayoutComponent, data: { module:'cpg' }, // Reports
    children: [
        { path: '', component: CouponReportComponent, canActivate: [AuthGuardService], data: { module:'cpg', menuCode: 'C-RP' } }
    ]
  },
  { path: 'cpg/payments', component: LayoutComponent, data: { module:'cpg' }, // Payments
    children: [
        { path: '', component: PaymentsComponent, canActivate: [AuthGuardService], data: { module:'cpg', menuCode: 'C-PA' } }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CpgRoutingModule { }
